import React from "react";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { Typography } from "@material-ui/core";
import MoodBadIcon from "@material-ui/icons/MoodBad";
import SentimentSatisfiedIcon from "@material-ui/icons/SentimentSatisfied";
import MoodIcon from "@material-ui/icons/Mood";

const NpsRadio = (props) => {
    const { options, isCompleted, onChange, value } = props;

    const color = useSelector(getAppColor);

    const getNPSIcon = (index) => {
        if (index > 7) return <MoodIcon style={{ fill: "var(--ownGreen)" }} />;
        if (index > 5) return <SentimentSatisfiedIcon style={{ fill: "var(--ownYellow)" }} />;
        return <MoodBadIcon style={{ fill: "var(--ownRed)" }} />;
    };

    return (
        <div style={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
            {options.map((item, index) => {
                const isSelected = item === value;
                return (
                    <div
                        key={item}
                        onClick={() => !isCompleted && onChange(item)}
                        style={{ padding: 10, margin: 10, cursor: !isCompleted && "pointer" }}
                    >
                        {getNPSIcon(index)}
                        <Typography
                            align="center"
                            style={{ color: isSelected ? color : "var(--mainText)", fontWeight: isSelected && 600 }}
                        >
                            {item}
                        </Typography>
                    </div>
                );
            })}
        </div>
    );
};

export default NpsRadio;
